import { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import UploadPdfButton from '@/components/UploadPDFButton/UploadPdfButton';
import routes from '@/routes';

import PDFEditSteps from './PDFEditSteps';

function HowTo() {
	const { t } = useTranslation();
	const location = useLocation();
	const refHowTo = useRef(null);

	useEffect(() => {
		const hashHowTo = routes.howTo.replace(/^\//, '');

		if (location.hash.includes(hashHowTo)) {
			setTimeout(() => {
				refHowTo.current.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'start'
				});
			}, 100);
		}
	}, [location]);

	return (
		<section
			className="container relative z-10 flex justify-center pt-[80px] md:lacks-hover:pt-[116px] lg:pt-[146px]"
			ref={refHowTo}
		>
			<div className="flex w-full flex-col items-center gap-12 lg:gap-[68px]">
				<div className="flex flex-col items-start gap-4 md:lacks-hover:items-center lg:can-hover:max-w-[711px] lg:can-hover:self-start">
					<h3 className="font-title text-[32px] font-semibold leading-10 md:lacks-hover:text-center md:lacks-hover:text-[40px] md:lacks-hover:leading-[52px] lg:can-hover:text-[56px] lg:can-hover:leading-[64px]">
						{t('home.howTo.title')}
					</h3>
					<h4 className="text-sm font-normal leading-6 md:lacks-hover:text-base md:lacks-hover:leading-7 lg:text-base lg:leading-7">
						{t('home.howTo.subtitle')}
					</h4>
				</div>
				<PDFEditSteps />
				<UploadPdfButton
					size="lg"
					className="mb-20 self-start md:lacks-hover:mb-[100px] md:lacks-hover:self-center lg:mb-[111px]"
				/>
			</div>
		</section>
	);
}

export default HowTo;
